export function TextBtn({
  children,
  onClick,
  defaultValue,
  value,
  className,
  disabled = false,
  required = false,
  align,
  style,
  onMouseOver,
  onMouseLeave

}) {
  return (
    <>
      <button
        style={style}
        className={className}
        disabled={disabled}
        value={value}
        onClick={onClick}
        defaultValue={defaultValue}
        required={required}
        align={align}
        onMouseOver={onMouseOver}
        onMouseLeave={onMouseLeave}
      >
        {children}
      </button>
    </>
  );
}

export function ContainedBtn({
  children,
  onClick,
  defaultValue,
  className,
  disabled = false,
  required = false,
  value,
  style,
  onMouseOver,
  onMouseLeave

}) {
  return (
    <>
      <button
        style={style}
        className={className}
        disabled={disabled}
        onClick={onClick}
        defaultValue={defaultValue}
        required={required}
        value={value}
        onMouseOver={onMouseOver}
        onMouseLeave={onMouseLeave}
      >
        {children}
      </button>
    </>
  );
}

export function OutlineBtn({
  children,
  onClick,
  className,
  defaultValue,
  disabled = false,
  required = false,
  style,
  onMouseOver,
  onMouseLeave
}) {
  return (
    <>
      <button
        style={style}
        className={className}
        disabled={disabled}
        onClick={onClick}
        defaultValue={defaultValue}
        required={required}
        onMouseOver={onMouseOver}
        onMouseLeave={onMouseLeave}
      >
        {children}
      </button >
    </>
  );
}
